import React, { useRef, useState, useEffect } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";

const currentYear = new Date().getFullYear();

const schema = yup.object({
  epaId: yup.string().nullable(),
  shipYear: yup.string().required(),
  rcra: yup.string().nullable(),
});

export default function LargeQuantityGeneratorsReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = true;
  const [initialFormValues, setInitialFormValues] = useState({
    shipYear: params && params.shipYear ? params.shipYear : currentYear,
    epaId: params && params.epaId ? params.epaId : "",
    rcra: params && params.rcra ? params.rcra === "true" : true,
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Large Quantity Generators Report");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/lqg"
  );

  const formConfig = [
    // {
    //   name: "multishipYear",
    //   config: {
    //     col: "md",
    //     validate: true,
    //     colWidth: "3",
    //     label: "Select a Year",
    //     placeholder: "Select a Year",
    //     type: "multi-select",
    //     apiEndpoint: "/api/v1/hwts/search/ship-years",
    //     hasApi: true,
    //   },
    // },
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Select a Year",
        placeholder: "Select a Year",
        type: "select3",
        apiEndpoint: "/api/v1/hwts/search/ship-years",
        hasApi: true,
      },
    },
    {
      name: "epaId",
      config: {
        col: "md",
        colWidth: "2",
        label: "ID Number",
        placeholder: "Enter an ID Number...",
        type: "text",
      },
    },
    {
      name: "rcra",
      config: {
        col: "md",
        colWidth: "2",
        label: "LQG Type",
        placeholder: "",
        type: "select3",
        data: [
          { label: "CA", value: false },
          { label: "RCRA", value: true },
        ],
      },
    },
    {
      name: "city",
      config: {
        col: "md",
        colWidth: "3",
        label: "City",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "county",
      config: {
        label: "County",
        col: "md",
        validate: true,
        colWidth: "3",
        placeholder: "Select a County",
        errorMessage: "A county is required.",
        type: "select3",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
      },
    },
  ];

  const customColumnDefs = [
    {
      headerName: "Ship Year",
      field: "Ship_Year",
      sortable: true,
    },
    {
      headerName: "ID Number",
      field: "ID_Number",
      sortable: true,
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      headerName: "City",
      field: "City",
      sortable: true,
    },
    {
      headerName: "County",
      field: "County",
      sortable: true,
    },
    {
      headerName: "January",
      children: [
        {
          headerName: "Non-Acute",
          field: "Jan_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-01-01"}&toDate=${params.data.Ship_Year + "-01-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Jan_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-01-01"}&toDate=${params.data.Ship_Year + "-01-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "February",
      children: [
        {
          headerName: "Non-Acute",
          field: "Feb_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-02-01"}&toDate=${params.data.Ship_Year + "-02-29"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Feb_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-02-01"}&toDate=${params.data.Ship_Year + "-02-29"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "March",
      children: [
        {
          headerName: "Non-Acute",
          field: "Mar_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-03-01"}&toDate=${params.data.Ship_Year + "-03-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Mar_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-03-01"}&toDate=${params.data.Ship_Year + "-03-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "April",
      children: [
        {
          headerName: "Non-Acute",
          field: "Apr_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-04-01"}&toDate=${params.data.Ship_Year + "-04-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Apr_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-04-01"}&toDate=${params.data.Ship_Year + "-04-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "May",
      children: [
        {
          headerName: "Non-Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-05-01"}&toDate=${params.data.Ship_Year + "-05-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
          field: "May_NonAcute",
        },
        {
          headerName: "Acute",
          field: "May_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-05-01"}&toDate=${params.data.Ship_Year + "-05-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "June",
      children: [
        {
          headerName: "Non-Acute",
          field: "Jun_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-06-01"}&toDate=${params.data.Ship_Year + "-06-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Jun_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-06-01"}&toDate=${params.data.Ship_Year + "-06-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "July",
      children: [
        {
          headerName: "Non-Acute",
          field: "Jul_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-07-01"}&toDate=${params.data.Ship_Year + "-07-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Jul_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-07-01"}&toDate=${params.data.Ship_Year + "-07-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "August",
      children: [
        {
          headerName: "Non-Acute",
          field: "Aug_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-08-01"}&toDate=${params.data.Ship_Year + "-08-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Aug_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-08-01"}&toDate=${params.data.Ship_Year + "-08-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "September",
      children: [
        {
          headerName: "Non-Acute",
          field: "Sep_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-09-01"}&toDate=${params.data.Ship_Year + "-09-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Sep_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-09-01"}&toDate=${params.data.Ship_Year + "-09-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "October",
      children: [
        {
          headerName: "Non-Acute",
          field: "Oct_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-10-01"}&toDate=${params.data.Ship_Year + "-10-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Oct_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-10-01"}&toDate=${params.data.Ship_Year + "-10-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "November",
      children: [
        {
          headerName: "Non-Acute",
          field: "Nov_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-11-01"}&toDate=${params.data.Ship_Year + "-11-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Nov_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-11-01"}&toDate=${params.data.Ship_Year + "-11-30"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
    {
      headerName: "December",
      children: [
        {
          headerName: "Non-Acute",
          field: "Dec_NonAcute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-12-01"}&toDate=${params.data.Ship_Year + "-12-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        },
        {
          headerName: "Acute",
          field: "Dec_Acute",
          cellRenderer: function (params) {
            if (params.value != null && params.value !== 0) {
              return (
                `<a href="/reports/manifest?epaId=${params.data.ID_Number}&fromDate=${params.data.Ship_Year + "-12-01"}&toDate=${params.data.Ship_Year + "-12-31"}&entityType=Generator" target="_">` +
                params.value +
                "</a>"
              );
            }
          },
        }
      ]
    },
  ]

  const reportDescription = (
    <p>
      Provides a list of generators who have shipped 1,000 kg or more of hazardous waste in one calendar month, and/or more than 1 kg of acutely or extremely hazardous per month (commonly referred to as Large Quantity Generators).
      Values in report are provided in <b>Tons</b>.
      <br /><br />
      <b>Disclaimer:</b> This report is generated by aggregating data acquired from reported manifests. Data from generators using the Consolidated Manifesting Procedure or treating waste onsite is not included in this report. DTSC cannot guarantee that the data accurately reflects the generator status, what was transported or produced.
      <br /><br />
      RCRA Large Quantity Generators (LQGs) generate:
      <ul style={{ listStyleType: "disc" }}>
        <li>
          1,000 kilograms (1.10231 tons) per month or more of <u>RCRA</u> Hazardous Waste.
        </li>
        <li>
          or more than one kilogram (0.00110231 tons) per month of Acute <u>RCRA</u> Hazardous Waste.
        </li>
      </ul>
      California Large Quantity Generators (LQGs) generate:
      <ul style={{ listStyleType: "disc" }}>
        <li>
          1,000 kilograms (1.10231 tons) per month or more of Hazardous Waste.
        </li>
        <li>
          or more than one kilogram (0.00110231 tons) per month of Acute Hazardous Waste.
        </li>
      </ul>
      <a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=37b8f0a281399d8555d04240bcb55f43&node=pt40.26.262&rgn=div5" target="_">See 40 CFR part 262 for a complete description of the RCRA LQG regulations</a>.
    </p>
  )

  return (
    <>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: pageTitle, url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        customColumnDefs={customColumnDefs}
        searchOnInit={searchOnInit}
        initialPageSize={25}
        reportDescription={reportDescription}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </>
  );
}